import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from "react-router-dom";
import { lazy, Suspense } from "react";
import ScrollToTop from "./components/ScrollToTop";

const Index = lazy(() => import("./pages/Index"));
const NotFound = lazy(() => import("./pages/NotFound"));
const CancelPage = lazy(() => import("./pages/CancelPage"));
const SuccessPage = lazy(() => import("./pages/SuccessPage"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));

const HeroStudy = import.meta.env.DEV ? lazy(() => import("./pages/HeroStudy")) : null;
const ArdosBookingPreview = import.meta.env.DEV ? lazy(() => import("./ardosbooking/ArdosBookingApp")) : null;

const PreviewMail = import.meta.env.DEV ? lazy(() => import("./pages/PreviewMail")) : null;

const queryClient = new QueryClient();

const Root = () => {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
};

const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      { path: "/", element: <Suspense fallback={<div>Loading...</div>}><Index /></Suspense> },
      { path: "/cancel", element: <Suspense fallback={<div>Loading...</div>}><CancelPage /></Suspense> },
      { path: "/success", element: <Suspense fallback={<div>Loading...</div>}><SuccessPage /></Suspense> },
      { path: "/privacy", element: <Suspense fallback={<div>Loading...</div>}><PrivacyPolicy /></Suspense> },
      ...(ArdosBookingPreview ? [{ path: "/ardosbooking", element: <Suspense fallback={<div>Laster…</div>}><ArdosBookingPreview /></Suspense> }] : []),
      ...(HeroStudy ? [{ path: "/design-study", element: <Suspense fallback={<div>Laster…</div>}><HeroStudy /></Suspense> }] : []),
      { path: "/brand-study", element: <Navigate to="/" replace /> },
      ...(PreviewMail ? [{ path: "/preview-mail", element: <Suspense fallback={<div>Laster…</div>}><PreviewMail /></Suspense> }] : []),
      { path: "*", element: <Suspense fallback={<div>Loading...</div>}><NotFound /></Suspense> },
    ],
  },
]);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <RouterProvider router={router} />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
